import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../components/DashboardLayout';
import DuplicateCourseRegistrationsView from '../../components/reports/DuplicateCourseRegistrationsView';

export default function DuplicateCourseRegistrationsReport() {
  const navigate = useNavigate();

  return (
    <DashboardLayout title="Students by Course (Duplicate Check)">
      <div className="mx-auto max-w-6xl">
        <div className="mb-4">
          <button
            type="button"
            onClick={() => navigate('/admin/report/monitor')}
            className="inline-flex items-center gap-1.5 text-xs font-medium px-3 py-2 border border-gray-300 rounded-lg text-gray-600 bg-white hover:bg-gray-50 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
            Monitor Report
          </button>
        </div>

        <div className="mb-6 border-b border-gray-200 pb-5">
          <h1 className="text-xl font-bold text-gray-900 tracking-tight">Students by Course (Duplicate Check)</h1>
          <p className="mt-1 text-sm text-gray-500">
            All students grouped by course name — courses that share a name but have different course IDs are merged
            into one group, surfacing students registered in two or more batches under what is really the same course.
          </p>
        </div>

        <DuplicateCourseRegistrationsView />
      </div>
    </DashboardLayout>
  );
}
